module.exports = __webpack_public_path__ + "img/teachizy_communaute.a7d38520.png";